import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import startCase from 'lodash/startCase'

import IconLink from 'components/Shared/IconLink/Index'
import colors from 'components/utils/colors'
import Tooltip from 'components/Shared/Tooltip/Index'


export const StyledDirectionSection = styled.div`
  display: flex;
  padding: 1px 3px 1px 0;
  box-sizing: border-box;
  order: 1;

  &:before {
    color: ${colors.secondary40} !important;
  }

  &:hover:before {
    color: ${colors.primary40} !important;
  }
`

const StyledIcon = styled(IconLink)`
  font-size: 12px;
  font-weight: 400;
`

const DirectionIcon = (props) => {
  const { t } = useTranslation()
  const sortDir = props.selectProps.sortDir
  const sortDirIcon = sortDir === 'desc' ? 'icon-arrow-down-16' : 'icon-arrow-up-16'

  const onClick = (e) => {
    e.stopPropagation()
    props.selectProps.changeDirectionOnClick()
  }

  return (
    <StyledDirectionSection
      data-tooltip-content={t('ticketProviderTicketsPage.sortDirectionTooltip')}
      data-tooltip-id='tooltip-direction-icon'
      onMouseDown={onClick}
    >
      <StyledIcon
        iconName={sortDirIcon}
        text={startCase(sortDir)}
      />
      <Tooltip id='tooltip-direction-icon' />
    </StyledDirectionSection>
  )
}

DirectionIcon.propTypes = {
  selectProps: PropTypes.object,
}

export default DirectionIcon
